module.exports = __webpack_public_path__ + "img/llantas.a839cd71.jpg";